<article
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="sessionExpiredTitle"
  class="tw-relative tw-flex tw-flex-col tw-bg-white tw-text-center"
>
  <h2 id="sessionExpiredTitle" class="tw-mb-6 tw-text-2xl tw-font-semibold tw-text-gray-900">
    {{ 'idle_session.expired_title' | translate }}
  </h2>

  <p class="tw-text-main-text">{{ 'idle_session.expired_message' | translate }}</p>
  <p class="tw-mt-4 tw-text-main-text">{{ 'idle_session.expired_hint' | translate }}</p>

  <section class="tw-mt-8 tw-flex tw-justify-center">
    <mh-core-lib-button
      [isPrimary]="true"
      [text]="'idle_session.go_to_login' | translate"
      [customClass]="'!tw-w-auto tw-min-w-[160px] tw-whitespace-nowrap'"
      (clicked)="close()">
    </mh-core-lib-button>
  </section>
</article>
